import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { LogoButtonComponent } from '../logo-button/logo-button.component';

@Component({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'header[capra-header]',
  imports: [CommonModule, LogoButtonComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'capra-header',
  },
})
export class HeaderComponent {
  @Input() text = '';
  @Input() navOpen = false;
  @Input() showHamburger = true;
  @Output() navToggleClick = new EventEmitter<void>();
}
